// extracted by mini-css-extract-plugin
export default {"card":"nZ-z","carouselContainer":"oZ-z","carouselContent":"pZ-z"};